import { Suspense, lazy } from 'react';
// components
// import LoadingScreen from '../components/loading-screen';
import LoadingProgressBar from '../components/Loading-ProgressBar';
// --------------------------------------------------------------------------------------------------------

const Loadable = (Component) => (props) =>
(
    <Suspense fallback={<LoadingProgressBar />}>
        <Component {...props} />
    </Suspense>
);
// --------------------------------------------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));

export const MasterList = Loadable(lazy(() => import('../pages/masterlist')));

export const Masters = Loadable(lazy(() => import('../pages/Masters')));
export const AdminMasters = Loadable(lazy(() => import('../pages/adminmasters')));
export const UserMasterList = Loadable(lazy(() => import('../pages/usermasterlist')));
export const UserData = Loadable(lazy(() => import('../pages/userdata')));
export const CutOffDatePage = Loadable(lazy(() => import('../pages/cutoffdatepage')));

export const TemplateMappingPage = Loadable(lazy(() => import('../pages/masters/TemplateMappingPage')));
export const DistributorConfigurationPage = Loadable(lazy(() => import('../pages/masters/distributorconfigurationpage')));

export const PageOne = Loadable(lazy(() => import('../pages/PageOne')));
export const PageTwo = Loadable(lazy(() => import('../pages/PageTwo')));
export const PageThree = Loadable(lazy(() => import('../pages/PageThree')));
export const PageFour = Loadable(lazy(() => import('../pages/PageFour')));
export const PageFive = Loadable(lazy(() => import('../pages/PageFive')));
export const PageSix = Loadable(lazy(() => import('../pages/PageSix')));

export const StepOne = Loadable(lazy(() => import('../pages/DataUpload/DataUploadStepOne')));
export const StepThree = Loadable(lazy(() => import('../pages/DataUpload/DataUploadStepThree')));

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const Help404 = Loadable(lazy(() => import('../pages/Help404')));
export const CommingSoonPage = Loadable(lazy(() => import('../pages/CommingSoonPage')));
export const MainLogin = Loadable(lazy(() => import('../pages/login')));

export const EntLogin = Loadable(lazy(() => import('../pages/entlogin')));
export const EntGateLogin = Loadable(lazy(() => import('../pages/entgatelogin')));

export const DashboardPage = Loadable(lazy(() => import('../pages/dealer/dashboardpage')));
export const DashboardParametersPage = Loadable(lazy(() => import('../pages/dealer/dashboard/dashboardparameterspage')));
export const AllProductsPage = Loadable(lazy(() => import('../pages/dealer/dashboard/allproductspage')));
export const AllCustomersPage = Loadable(lazy(() => import('../pages/dealer/dashboard/allcustomerspage')));

export const DealerDataMappingPage = Loadable(lazy(() => import('../pages/dealer/DealerDataMappingPage')));
export const DataMappingFormPage = Loadable(lazy(() => import('../pages/dealer/DataMappingFormPage')));
export const Mapping = Loadable(lazy(() => import('../pages/dealer/Mapping')));

export const MyRequestPage = Loadable(lazy(() => import('../pages/dealer/myrequestpage')));

export const ClosureMonthPage = Loadable(lazy(() => import('../pages/dealer/closuremonthpage')));

export const ManualDataPage = Loadable(lazy(() => import('../pages/manualdatapage')));
export const ManualDataCreate = Loadable(lazy(() => import('../pages/manualdata/manualdatacreate')));
export const CloseMonth = Loadable(lazy(() => import('../pages/manualdata/closemonth')));
export const ViewInvoiceForm = Loadable(lazy(() => import('../pages/manualdata/viewinvoiceform')));

export const DataUploadApprovePage = Loadable(lazy(() => import('../pages/JJMIUser/DataUploadApprovePage')));
export const ReprocessZylemDataPage = Loadable(lazy(() => import('../pages/JJMIUser/reprocesszylemdatapage')));
export const DataUploadPage = Loadable(lazy(() => import('../pages/JJMIUser/datauploadpage')));

export const DataMappingPage = Loadable(lazy(() => import('../pages/JJMIUser/datamappingpage')));
export const DataMappingProductPage = Loadable(lazy(() => import('../pages/JJMIUser/datamapping/datamappingproductpage')));
export const DataMappingAccountPage = Loadable(lazy(() => import('../pages/JJMIUser/datamapping/datamappingaccountpage')));
export const DataMappingSurgeonPage = Loadable(lazy(() => import('../pages/JJMIUser/datamapping/datamappingsurgeonpage')));
export const DataMappingImportStep1 = Loadable(lazy(() => import('../pages/JJMIUser/datamapping/datamappingimportstep1page')));
export const DataMappingImportStep2 = Loadable(lazy(() => import('../pages/JJMIUser/datamapping/datamappingimportstep2page')));
export const DataMappingImportStep3 = Loadable(lazy(() => import('../pages/JJMIUser/datamapping/datamappingimportstep3page')));
export const DataMappingDownloadStep2 = Loadable(lazy(() => import('../pages/JJMIUser/datamapping/datamappingdownloadstep2page')));

export const EnableReuploadPage = Loadable(lazy(() => import('../pages/JJMIUser/enablereuploadpage')));

export const DealerRequestPage = Loadable(lazy(() => import('../pages/JJMIUser/dealerrequestpage')));
export const DealerAccountRequestPage = Loadable(lazy(() => import('../pages/JJMIUser/dealerrequest/dealeraccountrequestpage')));
export const DealerSuregonRequestPage = Loadable(lazy(() => import('../pages/JJMIUser/dealerrequest/dealersugeonrequestpage')));

export const UploadStepOne = Loadable(lazy(() => import('../pages/dealer/upload/UploadStepOne')));
// export const UploadStepTwo = Loadable(lazy(() => import('../pages/dealer/upload/UploadStepTwo')));


export const UploadStepThree = Loadable(lazy(() => import('../pages/dealer/upload/UploadStepThree')));
export const DealerViewData = Loadable(lazy(() => import('../pages/dealer/ViewData')));
// export const MainUploadPage = Loadable(lazy(() => import('../pages/dealer/upload/MainUploadPage')));
export const DataUploadPageV1 = Loadable(lazy(() => import('../pages/dealerdatauploadv1/datauploadpagev1')));
export const DataUploadV1StepOne = Loadable(lazy(() => import('../pages/dealerdatauploadv1/datauploadv1stepone')));
export const DataUploadV1StepTwo = Loadable(lazy(() => import('../pages/dealerdatauploadv1/datauploadv1steptwo')));
export const UnmappedDataEntries = Loadable(lazy(() => import('../pages/dealer/upload/unmappeddataentries')));

export const SNSUploadPage = Loadable(lazy(() => import('../pages/dealer/snsupload/snsuploadpage')));
export const SNSUploadStep1 = Loadable(lazy(() => import('../pages/dealer/snsupload/snsuploadstep1page')));
export const SNSUploadStep2 = Loadable(lazy(() => import('../pages/dealer/snsupload/snsuploadstep2page')));
export const SNSViewDataPage = Loadable(lazy(() => import('../pages/dealer/snsupload/snsviewdatapage')));

export const NonEligibleRecordPage = Loadable(lazy(() => import('../pages/JJMIUser/noneligibilerecordspage')));

export const CommonPage = Loadable(lazy(() => import('../pages/CommonPage')));

export const OnlineEntryPage2 = Loadable(lazy(() => import('../pages/manualdata/onlineentrypage2')));
export const OnlineEntryPage4 = Loadable(lazy(() => import('../pages/manualdata/onlineentrypage4')));
export const CalenderPage = Loadable(lazy(() => import('../pages/calenderpage')));
export const OnlineEntryPage3 = Loadable(lazy(() => import('../pages/manualdata/onlineentrypage3')));
export const OnlineEntryPage5 = Loadable(lazy(() => import('../pages/manualdata/onlineentrypage5')));
export const RaiseTicketPage = Loadable(lazy(() => import('../pages/JJMIUser/raiseticketrequest/raiseticketpage')));
export const NotificationPage = Loadable(lazy(() => import('../pages/notificationpage')));
export const TransactionReportPage = Loadable(lazy(() => import('../pages/transactionreportpage')));
export const DealerPriceReport = Loadable(lazy(() => import('../pages/dealerpricereportpage')));
export const JJConnectLink = Loadable(lazy(() => import('../pages/jjconnectlink')));
export const ReportPage = Loadable(lazy(() => import('../pages/reportpage')));
export const DealerListPage = Loadable(lazy(() => import('../pages/dealerlistpage')));
export const SalesDashboardPage = Loadable(lazy(() => import('../pages/salesuser/salesdashboardpage')));
export const TransactionReport = Loadable(lazy(() => import('../pages/reports/transactionreport')));
export const DumpReport = Loadable(lazy(() => import('../pages/reports/dumpreport')));
export const SalesReport = Loadable(lazy(() => import('../pages/reports/salesreport')));
export const TerritoryDumpReport = Loadable(lazy(() => import('../pages/reports/territorydumpreport')));

export const DealerReport = Loadable(lazy(() => import('../pages/reports/dealerreport')));
export const DumpReportPage = Loadable(lazy(() => import('../pages/dumpreportpage')));
export const SalesReportPage = Loadable(lazy(() => import('../pages/mySalesReport')));
export const TerritoryDumpReportPage = Loadable(lazy(() => import('../pages/territorydumpreportpage')));

export const DealerPurchaseReportPage = Loadable(lazy(() => import('../pages/dealerpurchasereportpage')));
export const DealerPurchaseReport = Loadable(lazy(() => import('../pages/reports/dealerpurchasereport')));
export const DealerDataStatusReport = Loadable(lazy(() => import('../pages/reports/dealerdatastatusreport')));

export const DealerDataStatusReportPage = Loadable(lazy(() => import('../pages/dealerdatastatusreportpage')));

export const InventoryReportPage = Loadable(lazy(() => import('../pages/inventoryreportpage')));
export const InventoryReport = Loadable(lazy(() => import('../pages/reports/inventoryreport')));

export const CoeDataUploadPage = Loadable(lazy(() => import('../pages/JJMIUser/coedatauploadpage')));

export const CoeDataUploadStepOne = Loadable(lazy(() => import('../pages/JJMIUser/dataupload/coedatauploadstep1')));

export const CoeDataUpload = Loadable(lazy(() => import('../pages/JJMIUser/dataupload/coedataupload')));

export const CoeDataUploadStepTwo = Loadable(lazy(() => import('../pages/JJMIUser/dataupload/coedatauploadstep2')));

export const ActivityLogPage = Loadable(lazy(() => import('../pages/JJMIUser/activitylogpage')));
export const ActivityLog = Loadable(lazy(() => import('../pages/reports/activitylog')));

export const Errorpage = Loadable(lazy(() => import('../pages/ErrorPage')));
export const DealerReportedSNSDataPage = Loadable(lazy(() => import('../pages/dealerreportedsnspage')));
export const DealerReportedSNSDataReport = Loadable(lazy(() => import('../pages/reports/dealerreportedsnsreport')));

export const HelpAndDocuments = Loadable(lazy(() => import('../pages/helpanddocumentspage')));


export const HelpAndCommunicationViewPage = Loadable(lazy(() => import('../pages/helpandcommunicationviewpage')));


export const HelpTopics = Loadable(lazy(() => import('../pages/admin/helptopics')));
export const SubCategory = Loadable(lazy(() => import('../pages/admin/subcategory')));

export const AddEditHelpTopics = Loadable(lazy(() => import('../pages/admin/addedithelptopics')));
export const AddEditSubCategory = Loadable(lazy(() => import('../pages/admin/addeditsubcatgory')));
export const HelpCommonPage = Loadable(lazy(() => import('../pages/helpCommonpage')));

export const HelpCommunicationSearchPage = Loadable(lazy(() => import('../pages/helpandcommunicationsearchpage')));

export const DSRPDCPRIDumpPage = Loadable(lazy(() => import('../pages/NetRetail/dsr_pdc_priDump/DSRPDCPRIDumpPage')));
export const DSRPDCPRIDumpStep1 = Loadable(lazy(() => import('../pages/NetRetail/dsr_pdc_priDump/DSRPDCPRIDumpStep1')));
export const DSRPDCPRIDumpStep2 = Loadable(lazy(() => import('../pages/NetRetail/dsr_pdc_priDump/DSRPDCPRIDumpStep2')));

export const SupervisorMaster = Loadable(lazy(() => import('../pages/supervisor/supervisormaster')));

export const SupervisorDataUploadStepOne = Loadable(lazy(() => import('../pages/supervisor/DataUpload/DataUploadStepOne')));
// export const UploadStepTwo = Loadable(lazy(() => import('../pages/dealer/upload/UploadStepTwo')));

export const SupervisorDataUploadStepTwo = Loadable(lazy(() => import('../pages/supervisor/DataUpload/DataUploadStepThree')));

export const SetManagementCommonPage = Loadable(lazy(() => import('../pages/setmanagementcommonpage')));

export const RequestorPage = Loadable(lazy(() => import('../pages/BranchSecretory/requestorpage')));
export const HistoryPage = Loadable(lazy(() => import('../pages/BranchSecretory/historypage')));
export const SettingsPage = Loadable(lazy(() => import('../pages/BranchSecretory/settingspage')));
export const BSReportPage = Loadable(lazy(() => import('../pages/BranchSecretory/reportpage')));
export const AnalyticsPage = Loadable(lazy(() => import('../pages/BranchSecretory/analyticspage')));
export const MainRequestPage = Loadable(lazy(() => import('../pages/BranchSecretory/mainrequestpage')));
export const GeneralStepTwo = Loadable(lazy(() => import('../pages/BranchSecretory/generalpagesteptwo')));
export const GeneralStepThree = Loadable(lazy(() => import('../pages/BranchSecretory/generalpagestepthree')));

export const GeneralPreviewPage = Loadable(lazy(() => import('../pages/BranchSecretory/generalpreviewpage')));

export const ApproveStatusPage = Loadable(lazy(() => import('../pages/SetMgt/NSM/ApproveStatusPage')));

export const BSDashboardPage = Loadable(lazy(() => import('../pages/BranchSecretory/bsdashboardpage')));

// Added by shreyas marathe 06Dec2023
export const MainDealerPage = Loadable(lazy(() => import('../pages/SetMgt/Dealer/maindealerpage')));
export const AcknowledgementPage = Loadable(lazy(() => import('../pages/SetMgt/Dealer/acknowledgementpage')));

export const NSMDashoardPage = Loadable(lazy(() => import('../pages/SetMgt/NSM/nsmdashboardpage')));
export const NSMRequestPage = Loadable(lazy(() => import('../pages/SetMgt/NSM/nsmsetrequestmainpage')));

// summaya 

export const BSRequestorPage = Loadable(lazy(() => import('../pages/SetMgt/BS/bsrequestorpage')));
export const BSRequestorNewSetPage = Loadable(lazy(() => import('../pages/SetMgt/BS/newsetrequeststepone')));


export const DealerSNSReportPage = Loadable(lazy(() => import('../pages/dealersnsreportpage')));
export const DealerSNSReport = Loadable(lazy(() => import('../pages/reports/dealersnsreport')));

export const ReadOnlyMaster = Loadable(lazy(() => import('../pages/readonlymaster')));
export const ReadOnlyMasterList = Loadable(lazy(() => import('../pages/readonlymasterlist')));

export const GrossSalesReportPage = Loadable(lazy(() => import('../pages/grosssalesreportpage')));
export const GrossSalesReport = Loadable(lazy(() => import('../pages/reports/grosssalesreport')));
export const GrossSaleDetailedReportExport = Loadable(lazy(() => import('../pages/reports/grosssaledetailedreportexport')));

export const StandardPriceReportPage = Loadable(lazy(() => import('../pages/standardpricereportpage')));
export const StandardPriceReport = Loadable(lazy(() => import('../pages/reports/standardpricereport')));

export const ModuleRoleAccessListPage = Loadable(lazy(() => import('../pages/moduleroleaccesslistpage')));
export const ModuleRoleAccessList = Loadable(lazy(() => import('../pages/moduleroleaccesslist')));


export const YTDDumpReportPage = Loadable(lazy(() => import('../pages/ytddumpreportpage')));
export const YTDDumpReport = Loadable(lazy(() => import('../pages/reports/ytddumpreport')));


export const DataPage = Loadable(lazy(() => import('../pages/data/datapage')));
export const InventoryPage = Loadable(lazy(() => import('../pages/data/inventorypage')));
export const GrossSalePage = Loadable(lazy(() => import('../pages/data/grosssalepage')));


// Power BI Dashboard page : 23-Jun-2025 Added by Karishma
export const PowerBIDashboardPage = Loadable(lazy(() => import('../pages/dealer/powerbidashboardpage')));

export const Logout = Loadable(lazy(() => import('../pages/logout')));

export const FranchiseWiseCutOffPage = Loadable(lazy(() => import('../pages/JJMIUser/franchisewisecutoffpage')));


